"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseIp = void 0;

var _flow = _interopRequireDefault(require("lodash/flow"));

var _partialRight = _interopRequireDefault(require("lodash/partialRight"));

var _toNumber = _interopRequireDefault(require("lodash/toNumber"));

var _reduce = _interopRequireDefault(require("lodash/reduce"));

var _split = _interopRequireDefault(require("lodash/split"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description
 * parse Ip into {@link skybase-components.sb-ipv4-input.utils#IpChunk IpChunks}
 * @Function
 *
 * @name skybase-components.sb-ipv4-input.utils#parseIp
 * @param {String} text
 * @return {skybase-components.sb-ipv4-input.utils#IpChunk}
 */
var parseIp = function parseIp(text) {
  return (0, _flow.default)((0, _partialRight.default)(_split.default, '.'), (0, _partialRight.default)(_reduce.default, function (portions, portion, key) {
    portions[key] = !isNaN((0, _toNumber.default)(portion)) ? (0, _toNumber.default)(portion) : null;
    return portions;
  }, [0, 0, 0, 0]))(text);
};

exports.parseIp = parseIp;
//# sourceMappingURL=parse-ip.js.map